(() => {
  'use strict';

  const PRODUCT_CARD = '.nextdev--product-card';
  const HOVER_SELECTOR = '.placeholder-hover-state';

  const productCards = document.querySelectorAll(PRODUCT_CARD);

  if (productCards.length > 0) {
    document.addEventListener('pointerenter', (e) => {
      const card = (e.target instanceof Element) ? e.target.closest(PRODUCT_CARD) : null;
      if (!card || e.pointerType !== 'mouse') return;

      const hoverStateEl = card.querySelector(HOVER_SELECTOR);
      if (hoverStateEl != null && hoverStateEl.hasAttribute('preload')) {
        hoverStateEl.play();
      }
    }, true);
  
    document.addEventListener('pointerleave', (e) => {
      const card = (e.target instanceof Element) ? e.target.closest(PRODUCT_CARD) : null;
      if (!card || e.pointerType !== 'mouse') return;
      
      const hoverStateEl = card.querySelector(HOVER_SELECTOR);
      if (hoverStateEl != null && hoverStateEl.hasAttribute('preload')) {
        hoverStateEl.pause();
      }
    }, true);

    productCards.forEach(productCard => {
      const productCardColors = productCard.querySelectorAll('.nextdev--product-card--info--colors button');

      if (productCardColors.length > 0) {
        productCardColors.forEach(productCardColor => {
          productCardColor.addEventListener('click', (e) => {
            e.preventDefault();

            productCard.querySelector('.nextdev--product-card--info--colors button.active')?.classList.remove('active');

            const button = e.currentTarget;
            button.classList.add('active');

            const image = button.dataset.image;
            if (image) {
              const productCardImage = button.closest('.nextdev--product-card').querySelector('.nextdev--product-card--image a');
              productCardImage.innerHTML = `
              <figure class="img-wrap img-wrap-bg loading" aria-busy="true">
                <img
                  src="${image}" 
                  alt=""
                  decoding="async"
                  class="lazy-img"
                >
              </figure>`;
            }
          });
        });
      }
    });
  }

})();